import { FC, Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Title, IconButton, Container } from "../../shared/ui";
import { formatDate, generateMediaQuery } from "../../shared/lib/helpers";
import { getRouteBlogs } from "../../shared/constants/routes";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { CareerBackInterfacesDTOBlogBlogDto } from "../../shared/ApiContract/data-contracts";
import { BlogImage } from "../../entities/Blog/ui/BlogImage";

import styles from "./ArticleMain.module.scss";
import "../../shared/styles/quill.snow.css";

interface ArticleMainProps {
    data: CareerBackInterfacesDTOBlogBlogDto;
}
export const ArticleMain: FC<ArticleMainProps> = ({ data: { mainPictureId, title, creationDate, body } }) => {
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));
    const isTablet = useMediaQuery(
        `(${MediaQueryProperty.MinWidth}: ${MediaSizeEnum.sm}) and (${MediaQueryProperty.MaxWidth}: ${MediaSizeEnum.lg})`,
    );

    const navigate = useNavigate();

    const handleBack = () => navigate(getRouteBlogs());

    return (
        <section className={styles.wrapper}>
            <div className={styles.navigate}>
                {isMobile ? (
                    <Link to={getRouteBlogs()} className={styles.link}>
                        Вернуться к&nbsp;списку новостей
                    </Link>
                ) : (
                    <IconButton
                        className={styles.icon}
                        icon="left"
                        theme="light"
                        text="Вернуться к списку новостей"
                        onClick={handleBack}
                    />
                )}
            </div>
            <BlogImage previewImageId={mainPictureId} className={styles.poster} alt={title} />
            <Container marginSize={isTablet ? "" : "standard"}>
                <div className={styles.content}>
                    <div>
                        <Title level={1} className={styles.title}>
                            {title}
                        </Title>
                        {creationDate && <p className={styles.date}>{formatDate(creationDate)}</p>}
                    </div>

                    {body?.length && (
                        <div className={styles.description}>
                            {body.map((block, idx) => {
                                return (
                                    <Fragment key={idx}>
                                        {block.contentTitle && <Title level={2}>{block.contentTitle}</Title>}
                                        {block.contentText && (
                                            <div
                                                id="editor"
                                                className="ql-editor"
                                                dangerouslySetInnerHTML={{ __html: block.contentText }}
                                            />
                                        )}
                                        {block.imageContentId && <BlogImage previewImageId={block.imageContentId} />}
                                    </Fragment>
                                );
                            })}
                        </div>
                    )}
                </div>
            </Container>
        </section>
    );
};
